import { render, staticRenderFns } from "./PaymentAccounts.vue?vue&type=template&id=c204ecf6&"
import script from "./PaymentAccounts.vue?vue&type=script&lang=js&"
export * from "./PaymentAccounts.vue?vue&type=script&lang=js&"
import style0 from "./PaymentAccounts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports